import { LinkResolverFunction } from '@prismicio/helpers';

import type { FilledContentRelationshipField } from '@prismicio/types';

export const linkResolver: LinkResolverFunction = ({
  type,
  uid,
}: FilledContentRelationshipField) => {
  switch (type) {
    case 'pmco_portfolio_archive': {
      return '/portfolios';
    }
    case 'pmco_portfolio': {
      return `/portfolios/${uid}`;
    }
    case 'pmco_contact': {
      return `/contact`;
    }
    case 'web_landing': {
      return '/web';
    }
    case 'about_page': {
      return '/about-us';
    }
    case 'legal_page':
    default: {
      return '/quality-policy';
    }
  }
};
